/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  Flex,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  useSteps,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import {
  useEditCustomer,
  useGetCustomerDetails,
  useGetCustomerSlaDefaults,
} from "../../services/customer-api";
import {
  useLookupCurrency,
  useLookupDesignations,
} from "../../services/lookups-queries";
import CustomerInformation from "./addCustomer/customer-information";
// import Accounts from "./addCustomer/accounts";
// import ContactPerson from "./addCustomer/contact-persons";
// import ReplenishmentModels from "./addCustomer/replenishment-models";
import Contracts from "./addCustomer/contracts";
// import Insurance from "./addCustomer/insurance";
// import EscalationGroups from "./addCustomer/escalation-groups";
import Summary from "./addCustomer/summary";
// import OfferedServices from "./addCustomer/offered-services";
import { ModifyCustomerDetails } from "./helper";
import { emptyCustomer } from "./constants";
import LocationInitials from "./addCustomer/locationInitial";
import LastCallTime from "./addCustomer/last-call-time";
import CustomerServiceAccessTiming from "./addCustomer/customer-service-access-timing";

const steps = [
  { title: "Information" },
  // { title: "Accounts" },
  // { title: "Contacts" },
  // { title: "Insurance" },
  // { title: "Models" },
  { title: "Contracts" },
  { title: "Last Call Time" },
  // { title: "Offered Services" },
  // { title: "Escalations" },

  { title: "Service Access Timing" },
  { title: "Location Initials" },
];
export default function EditCustomer() {
  const [triggerValidation, setTriggerValidation] = useState(false);
  const [designationList, setDesignationList] = useState([]);
  const [customer, setCustomer] = useState({ ...emptyCustomer });
  const {
    mutate: getSlaDefaults,
    data: slaDefaultsRes,
    isPending: gettingSlaDefaults,
  } = useGetCustomerSlaDefaults();

  const [slaDefaults, setSlaDefaults] = useState(null);
  const { activeStep, setActiveStep } = useSteps({
    index: 1,
    count: steps.length,
  });
  const params = useParams();
  const navigate = useNavigate();

  const { data: currencyListRes, isPending: gettingCurrencyList } =
    useLookupCurrency();

  const {
    mutate: editCustomer,
    data: editCustomerRes,
    isPending: editingCustomer,
    error: editCustomerError,
  } = useEditCustomer();

  const {
    data: designations,
    isPending: gettingDesignations,
    error: designationError,
  } = useLookupDesignations();

  const {
    mutate: getCustomerDetails,
    data: customerDetailsRes,
    isPending: gettingCustomerDetails,
    reset: resetCustomerDetails,
  } = useGetCustomerDetails();

  useEffect(() => {
    if (params.customerId) {
      getCustomerDetails(params.customerId);
    }
  }, []);

  useEffect(() => {
    if (!params.customerId) return;

    getSlaDefaults(params.customerId);
  }, [params.customerId]);

  useEffect(() => {
    if (slaDefaultsRes?.data) {
      // console.log("SLA Defaults received:", slaDefaultsRes.data);
      setSlaDefaults(slaDefaultsRes.data);
    }
  }, [slaDefaultsRes]);

  useEffect(() => {
    if (editCustomerRes) {
      navigate(Paths.customers);
      return;
    }

    if (designations?.data) {
      setDesignationList(
        designations.data.map((des) => ({
          id: des.description,
          text: des.description,
        })),
      );
    }

    if (customerDetailsRes && currencyListRes && designations) {
      const _customer = ModifyCustomerDetails(
        customerDetailsRes.data,
        currencyListRes.data,
        designations.data,
      );

      setCustomer({ ..._customer });
      reset({
        clientId: _customer.clientId,
        name: _customer.name,
        shortName: _customer.shortName,
        customerType: _customer.customerType,
        customerCode: _customer.customerCode,
        status: _customer.status,
        hasSeparateDispenseCount: _customer.hasSeparateDispenseCount,
        requiresEVhr: _customer.requiresEVhr,
        requestedBy: _customer.requestedBy,
        comments: _customer.comments,
      });
      resetCustomerDetails();
    }
  }, [
    editCustomerRes,
    editCustomerError,
    designations,
    designationError,
    customerDetailsRes,
    currencyListRes,
  ]);
  const updateCustomerInfo = (information) => {
    const _customer = {
      ...customer,
      clientId: information.clientId,
      name: information.name,
      shortName: information.shortName,
      customerType: information.customerType,
      customerCode: information.customerCode,
      status: information.status,
      hasSeparateDispenseCount: information.hasSeparateDispenseCount,
      requiresEVhr: information.requiresEVhr,
      requestedBy: information.requestedBy,
      comments: information.comments,
    };
    setCustomer(_customer);
  };

  const getCustomerInformation = useMemo(
    () => ({
      clientId: customer.clientId,
      name: customer.name,
      shortName: customer.shortName,
      customerType: customer.customerType,
      customerCode: customer.customerCode,
      status: customer.status,
      hasSeparateDispenseCount: customer.hasSeparateDispenseCount,
      requiresEVhr: customer.requiresEVhr,
      requestedBy: customer.requestedBy,
      comments: customer.comments,
    }),
    [customer],
  );
  // const updateAccounts = (accounts) => {
  //   const _customer = {
  //     ...customer,
  //     accounts,
  //   };
  //   setCustomer(_customer);
  // };

  // const getAccounts = useMemo(() => [...customer.accounts], [customer]);

  // const updateContactPersons = (contactPersons) => {
  //   const _customer = {
  //     ...customer,
  //     contactPersons,
  //   };
  //   setCustomer(_customer);
  // };

  // const getContactPersons = useMemo(
  //   () => [...customer.contactPersons],
  //   [customer],
  // );

  // const updateReplenishmentModels = (replenishmentModels) => {
  //   const _customer = {
  //     ...customer,
  //     replenishmentModels,
  //   };
  //   setCustomer(_customer);
  // };

  // const getReplenishmentModels = useMemo(
  //   () =>
  //     customer.replenishmentModels.map((elm) => ({ ...elm, expanded: false })),
  //   [customer],
  // );

  // const updateInsuranceLimits = (insuranceLimits) => {
  //   const _customer = {
  //     ...customer,
  //     insuranceLimits,
  //   };
  //   setCustomer(_customer);
  // };

  // const getInsuranceLimits = useMemo(
  //   () => [...customer.insuranceLimits],
  //   [customer],
  // );
  const updateContracts = (contracts) => {
    const _customer = {
      ...customer,
      contracts,
    };
    setCustomer(_customer);
  };

  const getContracts = useMemo(() => [...customer.contracts], [customer]);

  // const getOfferedServices = useMemo(
  //   () => [...customer.offeredServices],
  //   [customer],
  // );

  const updateServices = (services) => {
    const _customer = {
      ...customer,
      offeredServices: services,
    };
    setCustomer(_customer);
  };
  const getEscalationGroups = useMemo(
    () => [...customer.escalationGroups],
    [customer],
  );
  const updateEscalationGroup = (escalationGroups) => {
    const _customer = {
      ...customer,
      escalationGroups,
    };
    setCustomer(_customer);
  };

  const updateLocationInitials = (locationInitials) => {
    const _customer = {
      ...customer,
      locationInitials,
    };
    setCustomer(_customer);
  };

  const updateLastCallTime = (lastCallTimings) => {
    setCustomer({ ...customer, lastCallTimings });
  };

  const updateCustomerServiceAccessTiming = (serviceWindows) => {
    setCustomer({ ...customer, serviceWindows });
  };
  const {
    handleSubmit,
    control,
    trigger,
    watch,
    resetField,
    reset,
    getValues,
    formState: { errors, isValid, isDirty },
  } = useForm({
    mode: "onChange",
    defaultValues: { ...getCustomerInformation },
  });
  useEffect(() => {
    if (activeStep === 1 && triggerValidation) {
      trigger();
    } else if (activeStep !== 1 && triggerValidation) {
      setTriggerValidation(false);
    }
  }, [triggerValidation, activeStep]);

  return (
    <>
      {gettingCustomerDetails ||
      editingCustomer ||
      gettingCurrencyList ||
      gettingDesignations ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Customers", link: Paths.customers },
            { text: "Edit Customer", isCurrentPage: true },
          ]}
        />

        <Stepper index={activeStep} size="sm" className="extra-small-stepper">
          {steps.map((step, index) => (
            <Step
              key={index}
              onClick={() => {
                if (activeStep === 1) {
                  updateCustomerInfo(getValues());
                }
                setActiveStep(index + 1);
              }}
            >
              <StepIndicator style={{ cursor: "pointer" }}>
                <StepStatus
                  complete={<StepIcon />}
                  incomplete={<StepNumber />}
                  active={<StepNumber />}
                />
              </StepIndicator>

              <div style={{ cursor: "pointer" }}>
                <StepTitle>{step.title}</StepTitle>
                <StepDescription>{step.description}</StepDescription>
              </div>

              <StepSeparator />
            </Step>
          ))}
        </Stepper>
        {!customer.clientId && !isDirty ? (
          <></>
        ) : (
          <Flex w="100%" mt="20px">
            <Card flexDirection="column" w="100%">
              <CardBody>
                <div className="add-location-form">
                  {activeStep === 1 ? (
                    <form>
                      <CustomerInformation
                        customerObject={getCustomerInformation}
                        onNextStep={(information) => {
                          setActiveStep(2);
                          updateCustomerInfo(information);
                        }}
                        handleSubmit={handleSubmit}
                        control={control}
                        errors={errors}
                        watch={watch}
                        resetField={resetField}
                        isValid={isValid}
                      />
                    </form>
                  ) : activeStep === 2 ? (
                    <Contracts
                      contracts={getContracts}
                      currencies={currencyListRes?.data || []}
                      slaDefaults={slaDefaults}
                      onPrevStep={(contracts) => {
                        setActiveStep(1);
                        updateContracts(contracts);
                      }}
                      onNextStep={(contracts) => {
                        setActiveStep(3);
                        updateContracts(contracts);
                      }}
                      addData={(data) => {
                        updateContracts(data);
                      }}
                    />
                  ) : activeStep === 3 ? (
                    <LastCallTime
                      lastCallTime={customer.lastCallTimings}
                      slaDefaults={slaDefaults}
                      onPrevStep={(lastCallTimings) => {
                        updateLastCallTime(lastCallTimings);
                        setActiveStep(2);
                      }}
                      onNextStep={(lastCallTimings) => {
                        updateLastCallTime(lastCallTimings);
                        setActiveStep(4);
                      }}
                      addData={(data) => updateLastCallTime(data)}
                    />
                  ) : activeStep === 4 ? (
                    <CustomerServiceAccessTiming
                      customerServiceAccessTiming={customer.serviceWindows}
                      slaDefaults={slaDefaults}
                      onPrevStep={(serviceWindows) => {
                        updateCustomerServiceAccessTiming(serviceWindows);
                        setActiveStep(3);
                      }}
                      onNextStep={(serviceWindows) => {
                        updateCustomerServiceAccessTiming(serviceWindows);

                        if (isValid) {
                          setActiveStep(5);
                        } else {
                          setActiveStep(1);
                          setTriggerValidation(true);
                        }
                      }}
                      addData={(data) =>
                        updateCustomerServiceAccessTiming(data)
                      }
                    />
                  ) : activeStep === 5 ? (
                    <LocationInitials
                      addedLocations={customer.locationInitials}
                      isValid={customer?.locationInitials?.length}
                      onAddLocations={updateLocationInitials}
                      onPrevStep={() => {
                        setActiveStep(4);
                      }}
                      onNextStep={() => {
                        setActiveStep(6);
                      }}
                    />
                  ) : activeStep === 6 ? (
                    <Summary
                      editing
                      customer={customer}
                      onPrevStep={() => {
                        setActiveStep(5);
                      }}
                      onCreateCustomer={(customerPayload) => {
                        editCustomer({
                          ...customerPayload,
                          id: params.customerId,
                        });
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </CardBody>
            </Card>
          </Flex>
        )}
      </div>
    </>
  );
}
